import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import {
  RECORD_ICONS,
  RECORD_ICON_BACKGROUND_COLORS,
  RECORD_ICON_DEFAULT_BACKGROUND_COLOR,
} from 'javascripts/record_icons';

export class RecordTypeColoredIcon extends Field {
  /**
   * All record types have an icon.
   */
  static availableForModel(modelClass, recordLayout) {
    return true;
  }

  get title() {
    return 'Record type colored icon';
  }

  get icon() {
    const { typename } = this.recordFields.modelClass;

    if (typename in RECORD_ICONS) {
      return RECORD_ICONS[typename];
    }

    throw new Error(`Missing icon for record type ${typename}`);
  }

  get backgroundColor() {
    const { typename } = this.recordFields.modelClass;

    if (typename in RECORD_ICON_BACKGROUND_COLORS) {
      return RECORD_ICON_BACKGROUND_COLORS[typename];
    }

    return RECORD_ICON_DEFAULT_BACKGROUND_COLOR;
  }

  exampleContents(): FieldContentsData {
    return {
      icon: {
        name: this.icon,
        color: 'white',
        className: `record-reference-pill__icon record-reference-pill__icon--${this.recordFields.modelClass.typename.toLowerCase()}`,
      },
    };
  }

  contentsForRecord(record): FieldContentsData {
    return {
      icon: {
        name: this.icon,
        color: 'white',
        backgroundColor: this.backgroundColor,
        className: `record-reference-pill__icon record-reference-pill__icon--${this.recordFields.modelClass.typename.toLowerCase()}`,
        rounded: true,
      },
    };
  }
}
